import { TemplateButtonsMapType } from '../types';

export const TemplateTypeButtonsMap: TemplateButtonsMapType = {
  'survey-form': ['view_survey_response'],
  invoice: ['view_order', 'view_invoice'],
  order_confirmed_seller: ['upload_invoice', 'view_order'],
  order_submitted: ['view_order'],
  order_modified: ['view_order'],
  new_order_created: ['view_order'],
  payment_request_with_invoices: ['review_invoice'],
  payment_request_with_amount: [],
  payment_confirmation: [],
  invoice_list: ['view_order', 'view_invoice'],
  payment_received: ['accept_payment', 'reject_payment'],
  unknown: [],
  campaign: ['view_campaign', 'create_order'],
  media: [],
  dispatch: ['view_dispatch'],
  contact: ['view_contact'],
};
